import useGlobalStore from '@stores/global';
import useFeatureFlagStore from '@stores/feature-flag';
import useThemeStore from '@stores/theme';
import useAppProgrammeStore from '@stores/app-programme-store';

export default {
  data() {
    return {
      store: useGlobalStore(),
      themeStore: useThemeStore(),
      featureFlagStore: useFeatureFlagStore(),
      programmeStore: useAppProgrammeStore(),
    };
  },

  methods: {
    logIn() {
      this.$logger.info('Logging in user', undefined, true);
      this.$http.get('/api/profile/user').then(response => {
        this.featureFlagStore.loadUser(response.data.id, response.data.email);
        this.store.logIn(response.data);
        this.themeStore.resolveThemePreference(response.data);
        this.$logger.info('Logged in user');
        const promises = [];

        if (this.store.appName === 'app') {
          promises.push(this.programmeStore.fetchProgrammes());
        }
        return Promise.all(promises).then(() => response.data);
      }).then(() => {
        if (this.store.appName === 'app' && !this.store.termsAccepted) {
          this.$router.push({ name: 'policy_accept_page' });
        } else if (this.$route.query.next) {
          const path = decodeURIComponent(this.$route.query.next);
          this.$router.push({ path });
        } else {
          this.$router.push({ path: '/' });
        }
      }).catch(err => {
        this.store.logOut();
        this.$logger.error('Error logging in user', undefined, err);
        this.$ktoast.showError(err, true);
      });
    },
  },
};
